export enum DataGridColumnType {
  Text,
  Number,
  Date,
  Time,
  Select,
  Boolean,
  Custom,
  MultiSelect,
  DateTime,
}
